var _circle, _circle2, _path, _circle3, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCarouselCrimininal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 154,
    viewBox: "0 0 168 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 77,
    r: 77,
    fill: "#DFEEFC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.6147,
    cy: 101.741,
    r: 19.2707,
    transform: "rotate(-4.74173 53.6147 101.741)",
    stroke: "#979DA2",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4187 72.4943L57.0805 71.527L59.5275 83.3329L44.9502 84.5421L45.4187 72.4943Z",
    fill: "#979DA1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.043,
    cy: 69.5721,
    r: 19.2707,
    transform: "rotate(-65.388 120.043 69.5721)",
    stroke: "#979DA2",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8318 61.9836L95.7053 51.3449L107.195 54.9993L101.103 68.2977L90.8318 61.9836Z",
    fill: "#979DA1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.1738,
    y: 69.0986,
    width: 14.3807,
    height: 7.19036,
    rx: 3.5,
    transform: "rotate(-90.6863 47.1738 69.0986)",
    stroke: "#979DA1",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9316,
    y: 48.1406,
    width: 14.3807,
    height: 7.19036,
    rx: 3.5,
    transform: "rotate(-53.605 47.9316 48.1406)",
    stroke: "#979DA1",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.584,
    y: 35.0742,
    width: 14.3807,
    height: 7.19036,
    rx: 3.5,
    transform: "rotate(10.2898 65.584 35.0742)",
    stroke: "#979DA1",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87.7383,
    y: 42.5166,
    width: 14.3807,
    height: 7.19036,
    rx: 3.5,
    transform: "rotate(79.6257 87.7383 42.5166)",
    stroke: "#979DA1",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9953 63.3033C51.9703 62.6134 51.3907 62.0744 50.7008 62.0995C50.0109 62.1245 49.4719 62.704 49.4969 63.3939L51.9953 63.3033ZM49.4969 63.3939L49.8204 72.3152L52.3188 72.2246L51.9953 63.3033L49.4969 63.3939Z",
    fill: "#979DA1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8027 46.9795L50.9083 55.7033",
    stroke: "#979DA1",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0898 38.0527L58.3481 39.8626",
    stroke: "#979DA1",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8496 44.1318L76.0605 39.7701",
    stroke: "#979DA1",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6055 56.915L86.6164 52.9315",
    stroke: "#979DA1",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCarouselCrimininal);
export default __webpack_public_path__ + "static/media/IcCarouselCrimininal.cb7840d214f34357a37617f6a3156303.svg";
export { ForwardRef as ReactComponent };